import installationInstructions from './installationInstructions';

const robbiContent = {
  installationInstructions
}

export { robbiContent };
